"use client";

import styled from "styled-components";

export const ScrambledText = styled.div`
  min-height: 1em;
`;
